// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1iz2b","header":"PatientBlock_header__34aZi","label":"PatientBlock_label__b1CMX","option":"PatientBlock_option__pTXy1"};